// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__yzGHy","loaderImage":"loader_loaderImage__ZdKb7"};